module.exports = __webpack_public_path__ + "img/timing-box-dark-es.5f2ad1f3.png";